import BlockView from 'views/block/base-block-view';
import PageService from 'services/page-service';
import PagePathTemplate from 'views/block/page-path/templates/page-path';
import EF from 'ef/ef';

/**
 * This block takes an array of paths that each take a page key and render blocks
 * based on whether or not that page is completed.
 * @extends BlockView
 * Content Attributes expected:
 * - paths: an array of page paths
 * The following parameters are for each path. A path can either have a page_key or a pages parameter:
 * - @param {string} page_key: used if path has 1 page. Note: this is kept for backwards compatibility.
 * - @param {array} pages: used if a path has 1 or more pages.
 * - @param {array} completed_blocks: blocks to render if the page is complete.
 * - @param {array} incomplete_blocks: blocks to render if the page is incomplete.
 * - @param {boolean} all_paths_required: determine if all paths needs to be completed to set the page-path to complete.
 */
export default class PagePathView extends BlockView {
  constructor(options) {
    super(options);
    this.template = PagePathTemplate;
    this.className = 'page-paths';
    this.pathsCompleted = 0;
    this.handleMultiplePages = this.handleMultiplePages.bind(this);
    !this.model.has('all_paths_required') && this.model.set('all_paths_required', true);
  }

  load() {
    EF.module.currentActivity.currentPage.set('pagePath', true);
    this.model.get('paths').forEach(this.handleMultiplePages);
  }

  /**
   * this method will handle either a single page in a path with the @param {string} page_key
   * or if a path has multiple pages with the @param {array} pages
   */

  handleMultiplePages(path) {
    let pathPages;
    const { pages, id, completed_blocks, incomplete_blocks, page_key } = path;
    if (pages) {
      pathPages = pages;
    } else if (page_key) {
      pathPages = [page_key]; //needs to be an array
    }
    const completed = [];
    let blocks;
    if (Array.isArray(pathPages)) {
      pathPages
        .map(page => PageService.getPageByKey(page))
        .forEach(page => {
          page.set('pagePath', true);
          completed.push(page.get('completed'));
        });
    }
    if (completed.every(p => p === true)) {
      blocks = completed_blocks;
      this.pathsCompleted++;
    } else {
      blocks = incomplete_blocks;
    }
    this.renderNestedBlocks(`${this.model.get('cid')}-${id}-blocks`, blocks);
  }

  isReady() {
    let ready = true;
    if (this.model.get('all_paths_required')) {
      ready = this.pathsCompleted === this.model.get('paths').length;
    }
    return ready;
  }

  play() {
    this.isReady() && this.readyToGo();
  }
}
